export const OAUTH_REDIRECT_STORAGE_KEY = "incept-benchmark.oauthRedirectTo";

export const sanitizeRedirectPath = (path, fallback = "/") => {
  if (typeof path !== "string" || !path) {
    return fallback;
  }

  const trimmedPath = path.trim();

  const hasControlCharacter = Array.from(trimmedPath).some((char) => {
    const charCode = char.charCodeAt(0);
    return charCode <= 31 || charCode === 127;
  });

  if (
    !trimmedPath.startsWith("/") ||
    trimmedPath.startsWith("//") ||
    trimmedPath.startsWith("/\\") ||
    hasControlCharacter
  ) {
    return fallback;
  }

  return trimmedPath;
};

export const buildAuthUrl = (mode = "signin", redirectTo) => {
  const params = new URLSearchParams({ auth: mode });

  if (redirectTo) {
    params.set("redirectTo", sanitizeRedirectPath(redirectTo));
  }

  return `/?${params.toString()}`;
};
